import type { CSSProperties } from 'react';

export interface InlineErrorProps {
  message: string;
  className?: string;
  style?: CSSProperties;
}

/**
 * The one error-banner component — formalises the `<p role="alert">` markup
 * that was previously hand-copied per file (TermsGateModal, OnboardingPage,
 * ForgotPasswordPage, ProfilePage, SettingsPage each wrote their own). Pure
 * dedup: same DOM output as before, so this introduces no new visual
 * pattern — `role="alert"` just can't be silently dropped by a future edit.
 */
export default function InlineError({ message, className, style }: InlineErrorProps) {
  return (
    <p role="alert" className={className} style={style}>
      {message}
    </p>
  );
}
